import { getRouteApi, useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { FoodRequestsScreen } from './FoodRequestsScreen';
import type { FoodRequestsSearch } from './food-requests-search';

const route = getRouteApi('/food-requests');

export function FoodRequestsRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();
  const navigateTo = useNavigate();

  const onSearchChange = useCallback(
    (next: FoodRequestsSearch) => {
      void navigate({ replace: true, search: () => definedSearchParams(next) });
    },
    [navigate],
  );

  const onOpenRequest = useCallback(
    (id: string) => {
      void navigateTo({ to: '/food-requests/$requestId', params: { requestId: id } });
    },
    [navigateTo],
  );

  return <FoodRequestsScreen search={search} onSearchChange={onSearchChange} onOpenRequest={onOpenRequest} />;
}
